import React from 'react'
import { useLocation } from 'react-router-dom'
import AgentHeader from '../Component/AgentHeader'

export default function AgentMain() {
    return (
       
       
            <AgentHeader />

    )
}
